import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import shortid from 'shortid';

import css from 'css';
import api from 'api';
import WP from 'WP';
import { arrayFromNumber, sortByPath } from 'helpers';
import { H3 } from 'partials/typography';
import RemoveIcon from 'images/RemoveIcon';
import { Select, Input, Button } from 'partials/formElements';

import {
    addProgramToCalculator,
    setCalculatorPrograms,
    removeProgramFromCalculator,
    updateCalculatorProgram,
    setSelectedProgramPost,
} from 'store';

class GradeConfigurator extends Component {

    constructor() {
        super();

        this.state = {
            customProgramInputValue: ''
        }
    }

    componentDidMount() {
        api.getCalculatorSets(); // sets (once fetched) will be availabel in store under "calculator" key
    }

    _onSelectSetDropdownChange(e) {
        const value = e.target.value;
        const set = this.props.sets.filter(set => set.title.rendered === value)[0];
        const setPrograms = set ? set.acf.calculator_set_subjects : [];

        this.props.setCalculatorPrograms(this._addMissingPropertiesToPrograms(setPrograms));
        this.props.setSelectedProgramPost(value);
    }

    _addMissingPropertiesToPrograms(programs) {
        return programs.map(program => ({ 
            ...program, 
            code: shortid.generate(), 
            grade: 0,
            languagePoints: this._getLanguagePointsForProgram(program.emnenavn),
        }));
    }

    _getLanguagePointsForProgram(programName) {
        return WP.options.subjects.reduce((acc, item) => {
            if(item.subject.trim() === programName.trim() && item.language_points) {
                acc = parseFloat(item.points.trim()) || 0;
            }
            return acc;
        }, 0)
    }

    _addPropertyToProgram(program, key, value) {
        const updatedProgram = { ...program, [key]: value };
        this.props.updateCalculatorProgram(updatedProgram);
    }

    _removePropertiesFromProgram(program, properties=[]) {
        let updatedProgram = { ...program };
        properties.forEach(key => {
            delete updatedProgram[key];
        });
        this.props.updateCalculatorProgram(updatedProgram);
    }

    _findProgramByCode(code, list) {
        return list.filter(p => p.code === code)[0];
    }

    _groupPrograms(programs) {
        let groups = {
            fellesfag: [],
            felles_programfag: [],
            valgfri_programfag: [],
            custom: []
        }

        programs.reduce((acc, program) => {
            switch(program.fag) {
                case 'Fellesfag' : acc.fellesfag.push(program); break;
                case 'Felles programfag' : acc.felles_programfag.push(program); break;
                case 'Valgfri programfag' : acc.valgfri_programfag.push(program); break;
                default : acc.custom.push(program);
            }
            return acc;
        }, groups);

        return groups;
    }

    _renderAddremoveExamButton(program) {
        const label = program.examGrade !== undefined && program.exam2Grade !== undefined ? 'Fjern eksamen' : 'Legg til eksamen';
        
        return <span className="add-exam" onClick={() => {
            if(program.exam2Grade === undefined) {
                const key = program.examGrade === undefined ? 'examGrade' : 'exam2Grade';
                this._addPropertyToProgram(program, key, 0);
            } else {
                this._removePropertiesFromProgram(program, ['examGrade', 'exam2Grade']);
            }
        }}>{label}</span>
    }

    _onRemoveProgramButtonClick(program) {
        this.props.removeProgramFromCalculator(program);
    }

    _renderProgramRow(program) {
        return(
            <ProgramRow key={program.code}>
                <div className="name">
                    {program.emnenavn}
                    <RemoveIcon color={css.colors.blue} onClick={() => this._onRemoveProgramButtonClick(program)} />
                </div>
                <div className="points">

                    {this._renderPointMarker({ code: program.code, key: 'grade', points: program.grade, label: 'Standpunkt' })}

                    {program.examGrade !== undefined && this._renderPointMarker({ code: program.code, key: 'examGrade', points: program.examGrade, label: 'Eksamen' })}

                    {program.exam2Grade !== undefined && this._renderPointMarker({ code: program.code, key: 'exam2Grade', points: program.exam2Grade, label: 'Eksamen' })}

                    <br/>

                    {this._renderAddremoveExamButton(program)}
                </div>
            </ProgramRow>
        );
    }

    _renderPointMarker({ code, key, points, label }) {
        return(
            <PointsMarker>
                {arrayFromNumber(6).map(i => {
                    return <div 
                        key={i+1} 
                        className={['mark', i+1 === points ? 'on' : ''].join(' ')} 
                        onClick={() => this._setPoints({ code, key, points: i+1 })}
                        >{i+1}</div>
                })}
                {label && <label>{label}</label>}
            </PointsMarker>
        );
    }

    _setPoints({ code, key, points }) {
        const selectedProgramByCode = this._findProgramByCode(code, this.props.programs);
        const poinstToSet = selectedProgramByCode[key] === points ? 0 : points;
        this.props.updateCalculatorProgram({...selectedProgramByCode, [key]: poinstToSet});
    }

    _onCustomProgramInputChange(e) {
        this.setState({ customProgramInputValue: e.target.value });
    }

    _onCustomProgramInputBlur() {

    }

    _renderSearchSuggestions() {
        const { programs } = this.props;
        const { customProgramInputValue } = this.state;

        const programNames = programs.map(p => p.emnenavn);
        const allSubjectsExcludingSelectedPrograms = WP.options.subjects.filter(item => !~programNames.indexOf(item.subject) );
        const filteredSubjects = allSubjectsExcludingSelectedPrograms
                                    .filter(item => ~item.subject.toLowerCase().indexOf(customProgramInputValue.trim().toLowerCase()));

        if(!customProgramInputValue.trim() || filteredSubjects.length === 0) return null;

        if(filteredSubjects.length === 1 && filteredSubjects[0].subject === customProgramInputValue) return null;

        return (
            <ul>
                {filteredSubjects.map((item, i) => <li key={i} onClick={() => this._onSuggestionItemClick(item)}>{item.subject}</li>)}
            </ul>
        );
    }

    _addCustomProgram(e) {

        if(!this.state.customProgramInputValue.trim()) return;

        this.props.addProgramToCalculator({
            emnenavn: this.state.customProgramInputValue,
            fag: '',
            code: shortid.generate(), 
            grade: 0,
            languagePoints: this._getLanguagePointsForProgram(this.state.customProgramInputValue),
        });

        this.setState({ customProgramInputValue: '' });
    }

    _onSuggestionItemClick(item) {
        this.setState({ customProgramInputValue: item.subject });
    }
  
    render() {
        const { programs, sets, selectedSet } = this.props;
        const { customProgramInputValue } = this.state;

        const grupedPrograms = this._groupPrograms(programs);

        return (
            <Wrapper>

                <Intro>
                    <H3>Legg til dine karakterer fra videregående</H3>
                </Intro>
                
                <Select 
                    value={selectedSet} 
                    label="Velg studieprogram" 
                    options={sortByPath(sets.map(s => ({ value: s.title.rendered, name: s.title.rendered })), 'name')} 
                    onChange={this._onSelectSetDropdownChange.bind(this)} 
                    className="select-set"
                />

                <ul>
                    {grupedPrograms.fellesfag[0] && <ProgramSectionHeader>Fellesfag</ProgramSectionHeader>}
                    {grupedPrograms.fellesfag.map(program => this._renderProgramRow(program))}
                    
                    {grupedPrograms.felles_programfag[0] && <ProgramSectionHeader>Felles programfag</ProgramSectionHeader>}
                    {grupedPrograms.felles_programfag.map(program => this._renderProgramRow(program))}

                    {grupedPrograms.valgfri_programfag[0] && <ProgramSectionHeader>Valgfrie programfag</ProgramSectionHeader>}
                    {grupedPrograms.valgfri_programfag.map(program => this._renderProgramRow(program))}

                    {grupedPrograms.custom[0] && <ProgramSectionHeader>Emne</ProgramSectionHeader>}
                    {grupedPrograms.custom.map(program => this._renderProgramRow(program))}
                </ul>

                {selectedSet &&
                    <AddCustomProgram>
                        <Input 
                            value={customProgramInputValue} 
                            onChange={this._onCustomProgramInputChange.bind(this)} 
                            placeholder="Søk etter fag her" 
                        />
                        <Button blue onClick={this._addCustomProgram.bind(this)}>Legg til<RemoveIcon color="#fff" /></Button>
                        {this._renderSearchSuggestions()}
                    </AddCustomProgram>
                }
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    sets: state.calculator.sets,
    programs: state.calculator.programs,
    selectedSet: state.calculator.selectedSet,
})

const actions = {
    addProgramToCalculator,
    setCalculatorPrograms,
    removeProgramFromCalculator,
    updateCalculatorProgram,
    setSelectedProgramPost,
}

export default connect(mapStateToProps, actions)(GradeConfigurator);

/*
|--------------------------------------------------------------------------
|  Styles
|--------------------------------------------------------------------------
*/
const Wrapper = styled.div`
    margin-bottom:100px;
    @media(max-width: 767px) {
        margin-bottom:40px;
    }

    .select-set {
        margin-bottom:70px;
        > div {
            width: 300px;
            justify-content: flex-start;
            padding-left: 15px;
        }
        @media(max-width: 767px) {
            margin-bottom:40px;
        }
        @media(max-width: 480px) {
            > div {
                width: 100%;
            }
        }
    }
`

const Intro = styled.div`
    margin-bottom: 20px;
    h2 {
        margin-bottom: 20px;
    }
`

const ProgramRow = styled.li`
    margin-bottom: 34px;

    .name {
        margin-bottom:24px;
        max-width: 220px;
        position: relative;
        padding-right: 20px;
        @media(max-width: 480px) {
            max-width:100%;
        }
        svg {
            position: absolute;
            right: 0;
            top: 50%;
            cursor: pointer;
            transform: translateY(-50%);
        }
    }

    .points {
        > br {
            display:none;
            @media(max-width: 960px) {
                display: block;
            }
        }
        .add-exam {
            cursor:pointer;
            text-decoration: underline;
            @media(max-width: 960px) {
                margin-top: 15px;
                display: inline-block;
            }
        }
    }
`

const PointsMarker = styled.div`
    display: inline-flex;
    cursor: pointer;
    margin-right:24px;
    position:relative;

    @media(max-width: 820px) {
        margin-top:30px;
    }

    label {
        position: absolute;
        top:-24px;
        left:0;
        font-size:12px;
    }

    .mark {
        margin-right:10px;
        width: 28px;
        height:28px;
        border: 1px solid ${css.colors.blue};
        border-radius: 28px;
        cursor: pointer;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all .2s ease-in-out;
        line-height: 1;
        @media(max-width: 767px) {
            width: 38px;
            height:38px;
        }
        &:hover {
            @media(min-width: 768px) {
                background: #E1EDFD;
            }
        }
        &.on {
            background: ${css.colors.blue};
            color: #fff;
        }
    }
`

const ProgramSectionHeader = styled.li`
    margin-bottom: 25px;
    font-weight: bold;
`

const AddCustomProgram = styled.div`
    display: inline-flex;
    padding-top:20px;
    position: relative;

    input {
        height:44px;
        border:none;
        border-bottom: 2px solid ${css.colors.blue};
        background: #F4F4F4;
        width: 245px;
        @media(max-width: 767px) {
            width:165px;
        }
    }

    button {
        padding: 0 15px;
        height: 44px;
        font-size: 16px;
        svg {
            transform: rotate(45deg);
            margin-left:15px;
        }
        &:hover {
            svg g {
                stroke: ${css.colors.main};
            }
        }
    }

    ul {
        position: absolute;
        top: 100%;
        left: 0;
        background: #fff;
        z-index: 1000;
        border: 2px solid ${css.colors.blue};
        border-top: none;
        width: 100%;
        max-height: 290px;
        overflow: auto;
        li {
            padding: 10px;
            background: #FCFCFC;
            transition:all .2s ease-in-out;
            cursor:pointer;
            &:nth-child(even) {
                background: #F7F7F7;
            }
            &:hover {
                @media(min-width: 767px) {
                    background: ${css.colors.blue};
                    color: #fff;
                }
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/Calculator/GradeConfigurator.js